import PromotionSelector from './PromotionSelector';
export default PromotionSelector;
